import { jsx } from "react/jsx-runtime";
import { getAppConsistentParams } from "../../../utils/appUtils.js";
import { getProductUrlV2 } from "../../../utils/productUtils.js";
import { PdpProductInfoCard } from "./PdpProductInfoCard.js";
function PdpProductInfoPartV2({
  data,
  primaryColor,
  primaryContrastText,
  appConfigId
}) {
  const { title, imageUrl, rating, reviewsCount, stacklineSku, productUrl } = data;
  const urlSearchParams = getAppConsistentParams(window.location.search);
  const pdpUrl = getProductUrlV2({
    title,
    stacklineSku,
    urlSearchParams,
    retailerProductPageUrl: productUrl,
    appConfigId
  });
  return /* @__PURE__ */ jsx(
    PdpProductInfoCard,
    {
      title,
      imageUrl,
      rating,
      reviewsCount,
      pdpUrl,
      primaryColor,
      primaryContrastText
    }
  );
}
export {
  PdpProductInfoPartV2
};
//# sourceMappingURL=PdpProductInfoPartV2.js.map
